import type { TCatalogType } from './types'

export const PRODUCT_CATEGORIES: Record<TCatalogType, number[]> = {
  agroproducts: [1, 2, 3],
  machinery: [4, 5, 6, 213, 259, 440, 619],
}
